import { render, staticRenderFns } from "./printDocument.vue?vue&type=template&id=773070c6&"
import script from "./printDocument.vue?vue&type=script&lang=js&"
export * from "./printDocument.vue?vue&type=script&lang=js&"
import style0 from "./printDocument.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../Users/Mac/Desktop/Code/permtang/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports